/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Tabs_Mysubscriptions1Inputs */

const id_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langganan Saya`)
};

const ms_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langganan Saya`)
};

const da_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mine Abonnementer`)
};

const de_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Abonnements`)
};

const en_us2_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Subscriptions`)
};

const es_es2_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis suscripciones`)
};

const es_mx2_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis suscripciones`)
};

const fil_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aking mga Subscription`)
};

const fr_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes abonnements`)
};

const it_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le mie sottoscrizioni`)
};

const hu_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feliratkozásaim`)
};

const nl_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mijn abonnementen`)
};

const no_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mine abonnementer`)
};

const pl_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moje subskrypcje`)
};

const pt_br2_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minhas assinaturas`)
};

const pt_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As minhas subscrições`)
};

const ro_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonamentele mele`)
};

const fi_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omat tilaukset`)
};

const sv_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mina prenumerationer`)
};

const vi_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng ký của tôi`)
};

const tr_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aboneliklerim`)
};

const cs_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moje odběry`)
};

const bg_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Моите абонаменти`)
};

const ru_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мои подписки`)
};

const uk_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мої підписки`)
};

const ar_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اشتراكاتي`)
};

const hi_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेरी सब्सक्रिप्शन`)
};

const th_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การสมัครรับของฉัน`)
};

const ja_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイサブスクリプション`)
};

const zh_cn2_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的订阅`)
};

const zh_hant1_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的訂閱`)
};

const ko_notifications_tabs_mysubscriptions1 = /** @type {(inputs: Notifications_Tabs_Mysubscriptions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 구독`)
};

/**
* | output |
* | --- |
* | "My Subscriptions" |
*
* @param {Notifications_Tabs_Mysubscriptions1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_tabs_mysubscriptions1 = /** @type {((inputs?: Notifications_Tabs_Mysubscriptions1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Tabs_Mysubscriptions1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "ms") return ms_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "da") return da_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "de") return de_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "en-US") return en_us2_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "es-ES") return es_es2_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "fil") return fil_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "fr") return fr_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "it") return it_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "hu") return hu_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "nl") return nl_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "no") return no_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "pl") return pl_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "pt") return pt_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "ro") return ro_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "fi") return fi_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "sv") return sv_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "vi") return vi_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "tr") return tr_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "cs") return cs_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "bg") return bg_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "ru") return ru_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "uk") return uk_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "ar") return ar_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "hi") return hi_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "th") return th_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "ja") return ja_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_tabs_mysubscriptions1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_tabs_mysubscriptions1(inputs)
	return ko_notifications_tabs_mysubscriptions1(inputs)
});
export { notifications_tabs_mysubscriptions1 as "notifications.tabs.mySubscriptions" }